import { AxiosResponse } from "axios";
import { api } from "../api";
import { ITag } from "../interfaces/tags";


export class TagService {

    async get (): Promise<AxiosResponse<ITag[]>> {
        return await api.get(`/tags`)
        .then((res: AxiosResponse<ITag[]>) => res)
        .catch((error) => error);
    }

    async post (payload: any): Promise<AxiosResponse<ITag>> {
        return await api.post(`/tags`, payload)
        .then((res: AxiosResponse<ITag>) => res)
        .catch((error) => error);
    }

    async delete (id: string): Promise<AxiosResponse> {
        return await api.delete(`/tags/${id}`)
        .then((res: AxiosResponse) => res)
        .catch((error) => error);
    }
}
// export const TagServiceGetAll = async (): Promise<AxiosResponse<ITag[]>> => {
//     return await api.get(`/tags`)
//     .then((res: AxiosResponse<ITag[]>) => res)
//     .catch((error) => error);
// }
// export const TagServicePost = async (payload: any): Promise<AxiosResponse<ITag>> => {
//     return await api.post(`/tags`, payload)
//     .then((res: AxiosResponse<ITag>) => res)
//     .catch((error) => error);
// }